import { render, staticRenderFns } from "./RefundRequests.vue?vue&type=template&id=0c3325e2&"
import script from "./RefundRequests.vue?vue&type=script&lang=js&"
export * from "./RefundRequests.vue?vue&type=script&lang=js&"
import style0 from "./RefundRequests.vue?vue&type=style&index=0&id=0c3325e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports